import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const serverApi = createApi({
  reducerPath: "serverApis",
  baseQuery,
  tagTypes: ["server"],
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    getServerPackages: builder.query({
      query: () => "server/packages",
      providesTags: ["server"],
    }),
    serverRegister: builder.mutation({
      query: (body) => ({
        url: "server/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["server"],
    }),
  }),
});

export const { useLazyGetServerPackagesQuery, useServerRegisterMutation } =
  serverApi;
